import { FreeSpinsInfoEvent, SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { CollapseGameConfig } from '../../reels_engine/free_fall_reels_engine/game_config/collapse_game_config';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { AbstractGameConfig } from '../../reels_engine/game_config/abstract_game_config';
import { GameStateMachine } from '../../reels_engine/state_machine/game-state-machine';
import { T_IGameConfigProvider } from '../../type_definitions';
import { IGameConfigProvider } from './interfaces/i_game_config_provider';

export const FAST_SPINS_COMPONENT = Symbol('FAST_SPINS_COMPONENT');

export const FAST_SPINS_INITIAL_SPEED = 1;
export const FAST_SPINS_SPEED = 6;

export class FastSpinsComponent {
  private readonly gameConfig: AbstractGameConfig;
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;

  private speedMultiplier: number;
  private _isFastSpinsActive: boolean = false;

  constructor(container: Container, speedMultiplier: number = FAST_SPINS_SPEED) {
    this.speedMultiplier = speedMultiplier;
    this.gameConfig = container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig;
    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
  }

  public get isFastSpinsActive(): boolean {
    const machineState = this.gameStateMachine.curResponse;

    return (
      this._isFastSpinsActive &&
      !machineState.isBonus &&
      !machineState.isScatter &&
      (this.gameStateMachine.isAutoSpins ||
        (!!machineState.freeSpinsInfo &&
          machineState.freeSpinsInfo.event !== FreeSpinsInfoEvent.FreeSpinsStarted))
    );
  }

  public set isFastSpinsActive(value: boolean) {
    this._isFastSpinsActive = value;
  }

  public toggleFastSpin(isFastSpinsActive: boolean): void {
    isFastSpinsActive ? this.enableFastSpin() : this.disableFastSpin();
  }

  public enableFastSpin(): void {
    this.isFastSpinsActive = true;
    this.setSpinSpeedValues(this.speedMultiplier);
  }

  public disableFastSpin(): void {
    this.isFastSpinsActive = false;
    this.setSpinSpeedValues(FAST_SPINS_INITIAL_SPEED);
  }

  public enableTurboSpin(): void {
    this.isFastSpinsActive = true;
    this.setSpinSpeedValues(this.speedMultiplier);
  }

  public deinitialize(): void {
    this.disableFastSpin();
  }

  public setSpeedMultiplier(speedMultiplier: number): void {
    this.speedMultiplier = speedMultiplier;
  }

  private setSpinSpeedValues(value: number): void {
    this.gameConfig.regularSpinConfig.speedMultiplier = value;
    this.gameConfig.freeSpinConfig.speedMultiplier = value;
    this.gameConfig.anticipationConfig.speedMultiplier = value;

    if (this.gameConfig instanceof CollapseGameConfig) {
      if (this.gameConfig.regularSpinCollapsingConfig.collapsingParameters) {
        this.gameConfig.regularSpinCollapsingConfig.collapsingParameters.spinSpeedMultiplier =
          value;
      }

      if (this.gameConfig.freeSpinCollapsingConfig.collapsingParameters) {
        this.gameConfig.freeSpinCollapsingConfig.collapsingParameters.spinSpeedMultiplier = value;
      }
    }
  }
}
